// Module
var code = "<div class=\"mx-content-widget-view--only-filtered\">\r\n\t{{'solutionBuilderAgent.components.mx-content-widget-view.enterSearchParametersToLoadData' | mxi18n}} {{'solutionBuilderAgent.common.or_label' | mxi18n}}\r\n\t<a ng-click=\"vm.parameters.loadOnlyFilteredData = false\">{{'solutionBuilderAgent.common.showAll' | mxi18n}} </a>\r\n</div>";
// Exports
export default code;